export interface DataItem {
    key: string;
    datum: string;
    uzivatel: string;
    zeme: string;
    flagCode: string;
    kategorie: string;
    nabidka: string;
    typ: string;
    id: string;
    odmena: string;
    castka: string;
}

export const data: DataItem[] = [
    {
        key: "1",
        datum: "10.11.2021 15:30",
        uzivatel: "John Dukes",
        zeme: "Česká republika",
        flagCode: "cz",
        kategorie: "Finance",
        nabidka: "AirBank",
        typ: "Lead",
        id: "200",
        odmena: "200",
        castka: "340.96",
    },
    {
        key: "2",
        datum: "10.11.2021 15:30",
        uzivatel: "Autumn Phillips",
        zeme: "Německo",
        flagCode: "de",
        kategorie: "Finance",
        nabidka: "AirBank",
        typ: "Lead",
        id: "201",
        odmena: "200",
        castka: "8,230.63",
    },
    {
        key: "3",
        datum: "10.11.2021 15:30",
        uzivatel: "Iva Ryan",
        zeme: "Velká Británie",
        flagCode: "gb",
        kategorie: "Finance",
        nabidka: "AirBank",
        typ: "Lead",
        id: "22",
        odmena: "200",
        castka: "8,048.35",
    },
    {
        key: "4",
        datum: "10.11.2021 15:30",
        uzivatel: "Kurt Bates",
        zeme: "Česká republika",
        flagCode: "cz",
        kategorie: "Finance",
        nabidka: "AirBank",
        typ: "Lead",
        id: "23",
        odmena: "200",
        castka: "1,986.99",
    },
    {
        key: "5",
        datum: "10.11.2021 15:30",
        uzivatel: "Paula Mora",
        zeme: "Česká republika",
        flagCode: "cz",
        kategorie: "Finance",
        nabidka: "AirBank",
        typ: "Lead",
        id: "234",
        odmena: "200",
        castka: "8,264.83",
    },
];
